import { render, staticRenderFns } from "./ExpenseTableMobile.vue?vue&type=template&id=4834557d&scoped=true&lang=pug"
import script from "./ExpenseTableMobile.vue?vue&type=script&lang=js"
export * from "./ExpenseTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4834557d",
  null
  
)

export default component.exports